<div class="modal-header">
	<h3 [i18n] eikey="{{ texts.title }}" [args]="texts"></h3>
</div>
<div class="modal-body">
	<p [i18n] eikey="{{ texts.prompt1 }}" [args]="texts" [count]="texts.count"></p>
	@if (texts.prompt2) {
		<p [i18n] eikey="{{ texts.prompt2 }}" args="contextData"></p>
	}
	@if (texts.prompt3) {
		<p [i18n] eikey="{{ texts.prompt3 }}" args="texts"></p>
	}
</div>
<div class="modal-footer">
	<button [ngStyle]="{ 'width.px': 100 }" class="btn btn-success mr-1" [i18n] eikey="{{ texts.positive }}" (click)="yep()">Yep</button>
	@if (texts.negative) {
		<button [ngStyle]="{ 'width.px': 100 }" class="btn btn-light mr-1" (click)="nope()" aria-label="Close" [i18n] eikey="{{ texts.negative }}">Nope</button>
	}
</div>
